import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Location } from "@angular/common";
import {
	MessageService,
	ConfirmationService,
	LazyLoadEvent,
} from "primeng/api";
import {
	Component,
	OnInit,
	Input,
	EventEmitter,
	Output,
	Inject,
} from "@angular/core";
import {
	FormBuilder,
	FormGroup,
	UntypedFormBuilder,
	Validators,
} from "@angular/forms";
import { AlertService, AuthenticationService, UserService } from "@app/_services";
import { ApiResponse, User } from "@app/_models";
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { ProformaService } from "../proforma.service";
import { Proforma } from "../proforma";
import { ProformaTemplateService } from "@app/_components/proforma-template/proforma-template.service";
import { PropertyService } from "@app/_components/property/property.service";
import { RealtorProfileService } from "@app/_components/realtor-profile/realtor-profile.service";
import { OwnerLeadProfileService } from "@app/_components/owner-lead-profile/owner-lead-profile.service";
import { PropertyLeadProfileService } from "@app/_components/property-lead-profile/property-lead-profile.service";
import { ProformaViewComponent } from "@app/_components/proforma-view/proforma-view.component";
import { ProformaCopyToFormComponent } from "@app/_components/proforma/proforma-copy-to-form/proforma-copy-to-form.component";
import { DialogService } from "primeng/dynamicdialog";
import { ProformaTargetComponent } from "./../../proforma-view/proforma-target/proforma-target.component";
//Parent Components
import { PropertyLeadProfileComponent } from "@app/_components/property-lead-profile/property-lead-profile/property-lead-profile.component";
import { PropertyLeadProfile } from "@app/_components/property-lead-profile/property-lead-profile";
import { RealtorProfileComponent } from "@app/_components/realtor-profile/realtor-profile/realtor-profile.component";
import { OwnerLeadProfileComponent } from "@app/_components/owner-lead-profile/owner-lead-profile/owner-lead-profile.component";
import { RealtorProfile } from "@app/_components/realtor-profile/realtor-profile";
import { OwnerLeadProfile } from "@app/_components/owner-lead-profile/owner-lead-profile";
import { Msg } from '../../msg/msg';
import { SendFullMailComponent } from '../../msg/send-full-mail/send-full-mail.component';
import { first, catchError, of } from 'rxjs';
import { PropertyMlsComponent } from "@app/_components/property/property-mls/property-mls.component";
import { ProformaCopyFromFormComponent } from "../proforma-copy-from-form/proforma-copy-from-form.component";
import { TravelAgentProfileService } from "@app/_components/travel-agent-profile/travel-agent-profile.service";
import { InboxMailSMsComponent } from "@app/_components/inbox/inbox-mail-sms/inbox-mail-sms.component";
import { MsgTemplateService } from "@app/_components/msg-template/msg-template.service";

@Component({
    selector: "app-proforma",
    templateUrl: "./proforma.component.html",
    styleUrls: ["./proforma.component.css"],
    providers: [DialogService, MessageService, ConfirmationService],
    standalone: false
})
export class ProformaComponent implements OnInit {
	// properties: any;
	realtorProperties: any[] = [];
	userProperties: any[] = [];
	ownerLeadProperties: any[] = [];
	propertyLeadProperties: any[] = [];
	proformaList: any[] = [];
	copyingProforma: any;
	copyingProperty: any;
	assignedToUserId;
	selectedTabIndex: number = 0;
	//proforma: any;

	realtorProfileId: any;
	realtorProfileIdRequired = false;

	ownerLeadProfileId: any;
	ownerLeadProfileIdRequired = false;

	propertyLeadProfileId: any;
	propertyLeadProfileIdRequired = false;

	userIdRequired = false;
	propertyLeadProfile: any;
	realtorProfile: any;
	ownerLeadProfile: any;
	proforma: any;
	templates: any[] = [];
	selectedTemplate: any = null;
	numProperties: number = 1;
	isRequestedProforma: boolean = false;
	updateIncome: boolean = false;
	updateExpense: boolean = false;
	agentUserSuggestions: string[];
	currentUser: any;
	logInUser: User;
	msg: Msg;
	createdBy: any;
	// shareProformaEmail: any = 'https://www.kbmresorts.com/proforma/CONFID/honua-kai/hkh-236';
	// shareProformaEmail: any = 'https://www.kbmresorts.com/bizdev/income-analysis/CONFID';
	shareProformaEmail: any = 'https://www.kbmresorts.com/bizdev/CONFID';

	//ownerLeadProfileFlag:Boolean = true;
	percentages: any;
	constructor(
		private realtorProfileService: RealtorProfileService,
		private ownerLeadProfileService: OwnerLeadProfileService,
		private propertyLeadProfileService: PropertyLeadProfileService,
		private userService: UserService,
		private authenticationService: AuthenticationService,
		private location: Location,
		private primengConfig: PrimeNGConfig,
		private proformaService: ProformaService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		// private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		private dialogService: DialogService,
		private travelAgentProfileService: TravelAgentProfileService,
		private msgTemplateService: MsgTemplateService,
		private proformaTemplateService: ProformaTemplateService,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		(this.formTitle = data.title),
			(this.proforma = data.proforma),
			this.statuses = proformaService.statuses;
		this.visibilities = proformaService.visibilities;
		this.authenticationService.currentUser.subscribe(currentUser => {
			this.logInUser = currentUser;
		});
		this.percentages = travelAgentProfileService.percentages;
		

	}

	//@Input() proforma: Proforma;
	//@Input() propertyLeadProfile: PropertyLeadProfile;
	//@Input() realtorProfile: RealtorProfile;
	//@Input() ownerLeadProfile: OwnerLeadProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doOpenCopiedProforma = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doClose = new EventEmitter<any>();

	// data
	proformaId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	dateOverLappingMsg: any;

	statuses: any;

	visibilities: any;

	isPublicAndPublish: boolean = false;

	proformaNotSelected: boolean = false;
	propertyNotSelected: boolean = false; // Flag for property validation

	propertyLeadProfiles: any = [];
	filteredPropertyLeadProfiles: any = [];

	realEstateProperties: any = [];

	validationMessages = {
		proformaId: [],
		// propertyLeadProfileId: [
		// 	{
		// 		type: "required",
		// 		message:
		// 			"Property Lead Profile is Required, if its not present in dropdown then add by Click on (+)Add button",
		// 	},
		// ],
		propertyLeadProfile: [{
			type: "required",
			message:
				"Property Lead Profile is Required, if its not present in dropdown then add by Click on (+)Add button",
		},],
		realtorProfileId: [],
		mlsAllId: [],
		ownerLeadProfileId: [],
		preparedDate: [],
		status: [],
		visibility: [{ type: "required", message: "Visibility Required" }],
		confId: [],
		createByProfile: [],
		name: [{ type: "required", message: "Name Required" }],

		estGrossRev: [],
		initialTermLengthMonths: [],
		subsequentTermLengthMonths: [],
		mgmtFeePCT: [],
		freeDepartureCleanNUM: [],
		freeCarDaysNUM: [],
		signCreditAMT: [],
		remodelCreditAMT: [],
		upgradeCredit: [],
		mgmtFeeCreditAMT: [],
		otherCreditAMT: [],
		termsSummaryDesc: []
	};
	viewStats: { viewCount: number; lastViewedAt: string } | null = null;
	viewStatsLoading = false;
	showProspectActivity = false;
	loadingsCounter = 0;
	loading = false;
	pdfLoading: boolean = false;
	mailComposeLoading: boolean = false;
	sendToProspectLoading: boolean = false;
	showSendToProspectForm: boolean = false;
	sendToProspectPayload: any = {
		recipientEmail: '',
		customSubject: 'Your KBM Resorts Rental Income Analysis',
		customMessage: ''
	};

	ngOnInit() {
		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.realEstateProperties.push(this.proforma?.realEstateProperty); // Show default one property loaded from Mls record to select same property from property lead profile
		this.setMlsPropertyDisplayLabel(this.proforma?.realEstateProperty); // Custome label on dropdown
		this.fetchRealtor();
		this.fetchTemplates();
		// this.fetchPropertLeadProfile();
		this.primengConfig.ripple = true;
		this.formBuild();
		if (this.proforma) {
			if (this.proforma.status == 4) {
				this.proforma.visibility = 0; // Default to public if proforma is requested
			}
			this.proformaId = this.proforma.proformaId;
			this.form1.patchValue({
				status: this.proforma.status,
				visibility: this.proforma.visibility,
				realtorProfileId: this.proforma.realtorProfileId,
				mlsAllId: this.proforma.realEstateProperty?.mlsAllId // Show default property selected from Mls record to select same property from property lead profile
			});
			this.setPropertyLead(this.proforma?.propertyLeadProfile);
			// If proforma is requested, show list of existing proforma to copy
			if (this.proforma.status == 4) {
				this.isRequestedProforma = true;
				let event: LazyLoadEvent = {};
				this.loadProformaList(event);
			} else {
				this.isRequestedProforma = false;
			}

			//Disable inputs if proforma is Public and Published
			if (this.proforma.status == 1 && this.proforma.visibility == 0) {
				this.isPublicAndPublish = true;
				this.disableInputs();
			}
		}
		if (!this.isRequestedProforma) {
			this.fetchOwnerLeadProfile();
			this.fetchUser();
			// if we were passed the whole proforma object
			if (this.proforma) {
				if (this.proforma.preparedDate != undefined && this.proforma.preparedDate != null) {
					this.proforma.preparedDate = moment.utc(this.proforma.preparedDate).toDate();
				}
				if (this.proforma.createByProfile != null) {
					this.proforma.createByProfile.summary = this.getAgentNameSummary(this.proforma.createByProfile);
				}
				this.fetchProformaById();
				this.loadViewStats();
				//this.fixDates();
				this.form1.patchValue(this.proforma);
			}
			if (this.proformaId == undefined) {
				this.currentUser.summary = this.getAgentNameSummary(this.currentUser);
				this.form1.patchValue({ createByProfile: this.currentUser });
			}
		}
		this.updatePropertyLeadProfileValidator();
	}

	setLoading(loading: boolean) {
		this.loadingsCounter += loading ? 1 : -1;
		if (this.loadingsCounter < 0) {
			this.loadingsCounter = 0;
		}
		this.loading = this.loadingsCounter > 0;
	}

	disableInputs() {
		this.form1.controls['name'].disable();
		this.form1.controls['status'].disable();
		this.form1.controls['preparedDate'].disable();
		this.form1.controls['visibility'].disable();
		this.form1.controls['createByProfile'].disable();
		// this.form1.controls['propertyLeadProfileId'].disable();
		this.form1.controls['propertyLeadProfile'].disable();
	}

	fetchProformaById() {
		try {
			this.formLoading = true;
			//pass this.confId in parameter below in kbmresorts
			this.proformaService.findById(this.proformaId)
				.subscribe(
					(res: any) => {
						this.dateOverLappingMsg = res.meta.Warning;
						this.createdBy = res.data.proforma?.createByProfile;
						this.shareProformaEmail = this.shareProformaEmail.replace("CONFID", res.data.proforma?.confId);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {

					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	setTarget() {
		const ref = this.dialogService.open(ProformaTargetComponent, {
			data: {
				proforma: this.proforma,
			},
			header: "Set " + this.proforma.name + " target",
			width: "auto",
		});
		ref.onClose.subscribe((form1: any) => {
			this.fetchProformaById();
			this.updateIncome = !this.updateIncome;
			this.doUpdate.emit(this.proforma);
		});
	}


	onSelectProforma(event: any) {
		if (this.proformaList.length > 0) {
			this.proformaList.forEach(proforma => {
				if (proforma.proformaId == event.value) {
					this.copyingProforma = proforma;
				}
			});
		}
	}

	loadProformaList(event: LazyLoadEvent) {
		this.formLoading = true;
		event.first = 0;
		event.rows = 1000;
		event.sortOrder = 1;
		event.multiSortMeta = [{ field: "createDate", order: -1 }];
		event.globalFilter = null;
		event.filters = { "status": { "value": [0, 1, 2, 3], "matchMode": "in" } }
		if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
			event.multiSortMeta = [];
			event.multiSortMeta.push({ field: 'createDate', order: -1 });
		}
		const pageNumber = Math.round(event.first / event.rows);
		this.proformaService.findByFilter(
			pageNumber, event.rows,
			event.sortField,
			event.sortOrder,
			event.multiSortMeta,
			event.globalFilter,
			event.filters).pipe(first()).subscribe(

				(res: any) => {
					if (res.data.proformas != undefined) {
						res.data.proformas.forEach(proforma => {
							var nameOption = proforma.name + ' - ';
							var subjAdrStreet = proforma.propertyLeadProfile?.subjAdrStreet != undefined ? (proforma.propertyLeadProfile?.subjAdrStreet) : '';
							var subjAdrUnit = proforma.propertyLeadProfile?.subjAdrUnit != undefined ? ('#' + proforma.propertyLeadProfile?.subjAdrUnit) : '';
							var subjAdrCity = proforma.propertyLeadProfile?.subjAdrCity != undefined ? (proforma.propertyLeadProfile?.subjAdrCity + ',') : '';
							var subjAdrState = proforma.propertyLeadProfile?.subjAdrState != undefined ? (proforma.propertyLeadProfile?.subjAdrState) : '';
							var stableYrGrossTtl = proforma.stableYrGrossTtl != undefined ? ('$' + proforma.stableYrGrossTtl) : '';
							var realtorFirstName = proforma.realtorProfile?.firstName != undefined ? (proforma.realtorProfile?.firstName + ' ') : '';
							var realtorLastName = proforma.realtorProfile?.lastName != undefined ? (proforma.realtorProfile?.lastName) : '';
							var realtorName = realtorFirstName + realtorLastName;
							var ownerFirstName = proforma.ownerLeadProfile?.firstName != undefined ? (proforma.ownerLeadProfile?.firstName + ' ') : '';
							var ownerLastName = proforma.ownerLeadProfile?.lastName != undefined ? (proforma.ownerLeadProfile?.lastName) : '';
							var ownerName = ownerFirstName + ownerLastName;
							var preparedDate = proforma.preparedDate != undefined ? (proforma.preparedDate) : '';
							var visibility = proforma.visibility != undefined ? (this.proformaService.getVisibilityName(proforma)) : '';
							proforma.customOption = nameOption + ' ' + subjAdrStreet + ' ' + subjAdrUnit + ' ' +
								subjAdrCity + ' ' + subjAdrState + ' ' + stableYrGrossTtl + ' ' + ownerName + ' ' +
								realtorName + ' ' + preparedDate + ' ' + visibility
						});
					}
					this.proformaList = res.data.proformas;
					console.log(JSON.stringify(res.page));
				},
				(err: any) => {
					console.log('reviews list error!: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; }
			);
	}

	getVisibilityName(proforma: any) {
		if (proforma?.visibility != undefined) {
			const visibility = this.visibilities.find((e: any) => e.value == proforma.visibility);
			return visibility.name;
		}
		else {
			return '';
		}
	}

	copyProformaFromExisting() {
		try {
			if (this.copyingProforma == undefined) {
				this.proformaNotSelected = true;
				return;
			}
			this.proformaNotSelected = false;

			//Property validation
			if (this.copyingProperty == undefined) {
				this.propertyNotSelected = true;
				return;
			}
			this.propertyNotSelected = false;
			let proforma: any = {
				proformaId: this.proformaId,
				copyFromProformaId: this.copyingProforma.proformaId,
				propertyLeadProfileId: this.copyingProperty.propertyLeadProfileId,
				visibility: this.form1.value.visibility,
				isRequestedProforma: this.isRequestedProforma
			};
			this.formLoading = true;
			this.proformaService.copyFromExistingProforma(proforma).subscribe(
				(res) => {
					console.log("Proforma-Copy SUCCESS: " + JSON.stringify(res));
					// this.alertService.success(res, true);
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: "Proforma copied successfully.",
						life: 3000,
					});
					setTimeout(() => {
						this.formLoading = false;
						this.doOpenCopiedProforma.emit(res.data.proforma);
					}, 1000)
				},
				(err) => {
					console.log("Proforma-Update FAIL: " + JSON.stringify(err));
					this.messageService.add({
						severity: "error",
						summary: JSON.stringify(err),
						life: 3000,
					});
				},
				() => {
					this.formLoading = false;
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	redirectToMlsProperty(mlsAllId) {
		window.open("http://localhost:4200/real-estate/details/" + mlsAllId, "_blank");
	}

	getAgentNameSummary(user: any) {
		let summary = "";
		if (user) {
			if (user.lastName) {
				summary = summary + user.lastName
			}
			if (user.firstName) {
				if (user.lastName) {
					summary = summary + ", " + user.firstName
				} else {
					summary = summary + user.firstName
				}
			}
			if (user.companyName) {
				summary = summary + " " + user.companyName
			}
		}
		return summary;
	}

	onFormDelete() {
		console.log("onRowDelete: " + JSON.stringify(event));
		this.confirmationService.confirm({
			message: "Are you sure you want to delete this proforma with Id# " + this.proformaId + "?",
			header: "Confirm",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({
					severity: "info",
					summary: "Canceled",
					detail: "Delete canceled.",
					life: 3000,
				});
			},
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log("property-add post: " + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.proformaService.add(this.form1.value).subscribe(
				(res: any) => {
					console.log("property-add SUCCESS: " + JSON.stringify(res));
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: res.message,
					});
					this.proforma = res.data.proforma;
					this.setPropertyLead(this.proforma?.propertyLeadProfile);
					this.proformaId = this.proforma.proformaId;
					this.formTitle = 'Edit Proforma'; // Form will be open on edit mode after adding proforma
					this.doAdd.emit(this.proforma);
					this.formLoading = false;
				},
				(err: any) => {
					console.log("proforma-add FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.formLoading = false;
				}
			);
		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	setAssignedToUserId($event) {
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	doUpdateProformaList() {
		this.doUpdate.emit(this.proforma);
	}

	formUpdate() {
		console.log("proforma: " + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.proformaId = this.proformaId;
			this.proformaId ? this.proformaService.update(this.form1.value).subscribe(
				(res: any) => {
					console.log("property-update SUCCESS: " + JSON.stringify(res));
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: res.message,
					});
					this.proforma = res.data.proforma;
					this.setPropertyLead(this.proforma?.propertyLeadProfile);
					this.formLoading = false;
					this.doUpdate.emit(this.proforma);
				},
				(err: any) => {
					console.log("property-update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => {
					this.formLoading = false;
				}
			) : this.formLoading = false;
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	setPropertyLead(propertyLeadPropery: any){
		if(propertyLeadPropery) {
			propertyLeadPropery = this.setPropertyLeadDisplayLabel(propertyLeadPropery);
			if (propertyLeadPropery.propertyLeadProfileId == this.proforma?.propertyLeadProfileId) {
				this.propertyLeadProfile = propertyLeadPropery;
				let filtered: any[] = [];
				filtered.push(propertyLeadPropery);
				this.filteredPropertyLeadProfiles = filtered;
				this.form1.patchValue({
					propertyLeadProfile: propertyLeadPropery
				});
			}
		}
	}

	formDelete() {
		try {
			this.setLoading(true);
			this.proformaService.delete(this.proforma.proformaId).subscribe(
				(res: any) => {
					console.log("proforma-delete SUCCESS: " + JSON.stringify(res));
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: this.proforma.name + ' deleted.',
					});
					this.doDelete.emit(this.proforma);
					this.setLoading(false);
				},
				(err: any) => {
					console.log("proforma-add FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
					this.setLoading(false);
				},
				() => {
					this.formLoading = false;
					this.setLoading(false);
				}
			);
		} catch (error) {
			this.alertService.error(error);
			this.setLoading(false);
		}
	}

	updatePropertyLeadProfileValidator() {
		const control = this.form1?.get('propertyLeadProfile');
		const statusControl = this.form1?.get('status');
		if (!control || !statusControl) return;
		const status = statusControl.value;
		if (status === 3) {
			control.setValidators([]);
		} else {
			control.setValidators([Validators.required]);
		}
		control.updateValueAndValidity({ emitEvent: false });
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			proformaId: [this.proformaId],
			propertyLeadProfileId: [],
			propertyLeadProfile: ["", Validators.required],
			mlsAllId: [],
			realtorProfileId: [],
			ownerLeadProfileId: [],
			preparedDate: [moment().toDate()],
			status: [0],
			visibility: [0, Validators.required],
			name: ["", Validators.required],
			propertyLeadProfiles: [],
			confId: [],
			createByProfile: [],
			proformaTemplateId: [],
			numProperties: [1],

			estGrossRev: [],
			initialTermLengthMonths: [],
			subsequentTermLengthMonths: [],
			mgmtFeePCT: [],
			freeDepartureCleanNUM: [],
			freeCarDaysNUM: [],
			signCreditAMT: [],
			remodelCreditAMT: [],
			upgradeCredit: [],
			mgmtFeeCreditAMT: [],
			otherCreditAMT: [],
			termsSummaryDesc: []
		});
		this.form1.get('status').valueChanges.subscribe(() => this.updatePropertyLeadProfileValidator());
		this.form1.get('proformaTemplateId').valueChanges.subscribe(() => this.onDealParamChange());
		this.form1.get('initialTermLengthMonths').valueChanges.subscribe(() => this.onDealParamChange());
		this.form1.get('numProperties').valueChanges.subscribe(() => this.onDealParamChange());
	}

	fetchTemplates() {
		this.proformaTemplateService.findActive().subscribe(
			(res: any) => {
				this.templates = res.data.proformaTemplates || [];
			},
			(err: any) => {
				console.log('fetchTemplates error: ' + JSON.stringify(err));
			}
		);
	}

	onDealParamChange() {
		const templateId = this.form1.get('proformaTemplateId')?.value;
		if (!templateId) {
			return;
		}
		const template = this.templates.find(t => t.proformaTemplateId === templateId);
		if (!template) {
			return;
		}
		const base: number = template.baseMgmtFeePCT;
		const floor: number = template.mgmtFeeFloorPCT;
		const ceiling: number = template.mgmtFeeCeilingPCT;
		const perProperty: number = template.perPropertyDiscountPCT;
		const perMonth: number = template.perTermMonthDiscountPCT;
		if (base == null || floor == null || ceiling == null) {
			return;
		}
		const props: number = Math.max(1, this.form1.get('numProperties')?.value ?? 1);
		const termMonths: number = Math.max(0, this.form1.get('initialTermLengthMonths')?.value ?? 0);
		const propertyDiscount = (perProperty ?? 0) * (props - 1);
		const termDiscount = (perMonth ?? 0) * termMonths;
		let computed = base - propertyDiscount - termDiscount;
		computed = Math.max(floor, Math.min(ceiling, computed));
		computed = Math.round(computed * 100) / 100;
		this.form1.get('mgmtFeePCT').setValue(computed, { emitEvent: false });
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.proforma.proformaDate = moment(this.proforma.proformaDate).toDate();
	}

	filterProperties(name: any) {

		this.propertyLeadProfileService.search(name).then(value => {
			console.log(value);
			this.filteredPropertyLeadProfiles = value.search.map((item: any) => {
				return {
					propertyLeadProfileId: item?.propertyLeadProfileId,
					firstName: item?.firstName,
					lastName: item?.lastName,
					subjAdrDevelopmentName: item?.subjAdrDevelopmentName,
					subjAdrStreet: item?.subjAdrStreet,
					summary: item?.subjAdrStreet + " " + item?.subjAdrDevelopmentName + " " + item?.firstName + " " + item?.lastName + " " + item?.propertyLeadProfileId,
					displayLabel: item?.subjAdrStreet + " " + item?.subjAdrDevelopmentName + " " + item?.firstName + " " + item?.lastName + " " + item?.propertyLeadProfileId
					// subjAdrUnit: item.subjAdrUnit,
					// subjAdrCity: item.subjAdrCity,
					// subjAdrState: item.subjAdrState
				}
			});
		})

		// let filtered: any[] = [];
		// let query = event.query;

		// if(this.form1.value.propertyLeadProfiles == null || this.form1.value.propertyLeadProfiles.length == 0) {
		// 	for (let i = 0; i < (this.propertyLeadProperties as any[]).length; i++) {
		// 		let property = (this.propertyLeadProperties as any[])[i];
		// 		if (property.displayLabel.toLowerCase().indexOf(query.toLowerCase()) != -1) {
		// 			filtered.push(property);
		// 		}
		// 	}
		// }

		// this.filteredPropertyLeadProfiles = filtered;
	}

	onPropertySelect(event) {
		console.log('onPropertySelect: ' + JSON.stringify(event));
		this.copyingProperty = event;
	}

	//Add property lead profile if not exists for request proforma
	addNewProperty() {
		let property = this.proforma.realEstateProperty;
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = "80vw";
		dialogConfig.maxWidth = "1600px";
		// dialogConfig.height = "100vh";
		// dialogConfig.maxHeight = "100vh";

		dialogConfig.data = {
			title: "Add Property Lead Profile",
			isDisplayOwnerProfile: false,
			mlsAllId: property?.mlsAllId,
			addressStreetName: property?.addressStreetName,
			addressUnit: property?.addressUnit,
			addressCity: property?.addressCity,
			addressState: property?.addressState,
			addressZip: property?.addressZip
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			PropertyLeadProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {

			console.log("Dialog output:", data);
			this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address added Successfully.', life: 3000 });
			this.propertyLeadProfileId = data.propertyLeadProfileId;
			this.setPropertyLead(data?.propertyLeadProfile);
			dialogRef.close();
		});
	}
	
	onOpenFormEdit() {
		if (this.shareProformaEmail) {
			window.open(this.shareProformaEmail, '_blank'); // open in new tab
		}
		else {
			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.maxWidth = "100vw";
			//dialogConfig.maxHeight = '100vh'
			//dialogConfig.height = '95vh'
			dialogConfig.width = "2150px";
			dialogConfig.panelClass = "my-class";

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				//ownerStmt: this.ownerStmt,
				proforma: this.proforma,
				ownerEmail: this.ownerLeadProfile?.emailAddress,
				title: "Edit Proforma",
			};

			// open the popup and get a reference to it called dialogRef
			let dialogRef = this.dialog.open(ProformaViewComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe((data) => {
				console.log("Dialog output:", data);
				this.proformaId = data.proformaId;
				this.updateIncome = !this.updateIncome;
				this.updateExpense = !this.updateExpense;
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//	this.updateOwnerStmtCB(data);

				// close the dialogBox
				// dialogRef.close();
			});

			dialogRef.componentInstance.doAdd.subscribe((data) => {
				this.updateIncome = !this.updateIncome;
				this.updateExpense = !this.updateExpense;
			});

			dialogRef.componentInstance.doDelete.subscribe((data) => {
				console.log("Dialog output:", data);
				this.updateIncome = !this.updateIncome;
				this.updateExpense = !this.updateExpense;
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.deleteOwnerStmtCB(data);

				// close the dialogBox
				// dialogRef.close();
			});
		}
	}

	//Relator Profile

	fetchRealtor() {
		try {
			this.setLoading(true);
			this.realtorProfileService.findAll().subscribe(
				(res) => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.realtorProperties = res.data.realtorProfiles;
					if (this.realtorProperties.length > 0) {
						this.realtorProperties.forEach(realtorProperty => {
							if (realtorProperty.realtorProfileId == this.proforma?.realtorProfileId) {
								this.realtorProfile = realtorProperty;
							}
							//set custom option label
							realtorProperty = this.setRealtorDisplayLabel(realtorProperty);
						});
					}
					this.setLoading(false);
					return this.realtorProperties;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
					this.setLoading(false);
				},
				() => { 
					this.setLoading(false);
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
			this.setLoading(false);
		}
	}

	//OwnerLead Profile

	fetchOwnerLeadProfile() {
		try {
			this.setLoading(true);
			this.ownerLeadProfileService.findAll().subscribe(
				(res) => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.ownerLeadProperties = res.data.ownerLeadProfiles;
					if (this.ownerLeadProperties.length > 0) {
						this.ownerLeadProperties.forEach(ownerLeadProperty => {
							if (ownerLeadProperty.ownerLeadProfileId == this.proforma?.ownerLeadProfileId) {
								this.ownerLeadProfile = ownerLeadProperty;
							}
							//set custom option label
							ownerLeadProperty = this.setOwnerLeadDisplayLabel(ownerLeadProperty);
						});
					}
					return this.ownerLeadProperties;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { 
					this.setLoading(false);
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
			this.setLoading(false);
		}
	}

	//User profile

	fetchUser() {
		try {
			this.setLoading(true);
			this.userService.findAll().subscribe(
				(res) => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.userProperties = res.data.users;
					return this.userProperties;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { 
					this.setLoading(false);
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
			this.setLoading(false);
		}
	}

	//PropertyLead Profile

	fetchPropertLeadProfile() {
		try {
			this.setLoading(true);
			this.propertyLeadProfileService.fastSearch().subscribe(
				(res) => {
					this.propertyLeadProperties = res.data.propertyLeadProfiles;
					if (this.propertyLeadProperties.length > 0) {
						this.propertyLeadProperties.forEach(propertyLeadPropery => {
							//set custom option label
							propertyLeadPropery = this.setPropertyLeadDisplayLabel(propertyLeadPropery);
							if (propertyLeadPropery.propertyLeadProfileId == this.proforma?.propertyLeadProfileId) {
								this.propertyLeadProfile = propertyLeadPropery;
								let filtered: any[] = [];
								filtered.push(propertyLeadPropery);
								this.filteredPropertyLeadProfiles = filtered;
								this.form1.patchValue({
									propertyLeadProfile: propertyLeadPropery
								});
							}

							//Show default selected if new property added for requested Proforma
							if (propertyLeadPropery.propertyLeadProfileId == this.propertyLeadProfileId) {
								this.propertyLeadProfiles = [];
								this.propertyLeadProfiles.push(propertyLeadPropery);
								this.form1.patchValue({
									propertyLeadProfiles: this.propertyLeadProfiles
								});
								this.copyingProperty = propertyLeadPropery;
							}
						});
					}
					return this.propertyLeadProperties;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { 
					this.setLoading(false);
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
			this.setLoading(false);
		}
	}

	onPropertyLeadProfileSelect(selectedItem: any) {
		console.log("Selected property lead profile:", selectedItem);
		this.form1.patchValue({
			propertyLeadProfileId: selectedItem.propertyLeadProfileId
		});
		this.formUpdate();
	}

	setOwnerLeadDisplayLabel(ownerLeadProperty) {
		ownerLeadProperty.displayLabel = "";
		if (ownerLeadProperty.lastName != null) {
			ownerLeadProperty.displayLabel = ownerLeadProperty.displayLabel + " " + ownerLeadProperty.lastName;
		}
		if (ownerLeadProperty.firstName != null) {
			ownerLeadProperty.displayLabel = ownerLeadProperty.displayLabel + " " + ownerLeadProperty.firstName;
		}
		if (ownerLeadProperty.subjAdrStreet != null) {
			ownerLeadProperty.displayLabel = ownerLeadProperty.displayLabel + " " + ownerLeadProperty.subjAdrStreet;
		}
		if (ownerLeadProperty.displayLabel == "") {
			ownerLeadProperty.displayLabel = "NA";
		}
		return ownerLeadProperty;
	}

	setRealtorDisplayLabel(realtorProperty) {
		realtorProperty.displayLabel = "";
		if (realtorProperty.lastName != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + " " + realtorProperty.lastName;
		}
		if (realtorProperty.firstName != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + " " + realtorProperty.firstName;
		}
		if (realtorProperty.adrCompanyName != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + " : " + realtorProperty.adrCompanyName;
		}
		if (realtorProperty.adrCity != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + " " + realtorProperty.adrCity;
		}
		if (realtorProperty.adrState != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + " " + realtorProperty.adrState;
		}
		if (realtorProperty.emailAddress != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + ", ✉ " + realtorProperty.emailAddress;
		}
		if (realtorProperty.mobilePhone != null) {
			realtorProperty.displayLabel = realtorProperty.displayLabel + ", ☎ " + realtorProperty.mobilePhone;
		}
		if (realtorProperty.displayLabel == "") {
			realtorProperty.displayLabel = "NA";
		}
		return realtorProperty;
	}

	setPropertyLeadDisplayLabel(propertyLeadPropery) {
		propertyLeadPropery.displayLabel = "";
		if (propertyLeadPropery.subjAdrDevelopmentName != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + propertyLeadPropery.subjAdrDevelopmentName;
		}
		if (propertyLeadPropery.subjAdrStreet != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrStreet;
		}
		if (propertyLeadPropery.subjAdrUnit != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrUnit;
		}
		if (propertyLeadPropery.subjAdrCity != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrCity;
		}
		if (propertyLeadPropery.subjAdrState != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrState;
		}
		if (propertyLeadPropery.subjAdrPostalCode != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrPostalCode;
		}
		if (propertyLeadPropery.displayLabel == "") {
			propertyLeadPropery.displayLabel = "NA";
		}
		return propertyLeadPropery;
	}

	setMlsPropertyDisplayLabel(realEstateProperty) {
		if (realEstateProperty != undefined) {
			realEstateProperty.displayLabel = "";
			if (realEstateProperty.addressStreetNumber != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + realEstateProperty.addressStreetNumber;
			}
			if (realEstateProperty.addressStreetName != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + " " + realEstateProperty.addressStreetName;
			}
			if (realEstateProperty.addressUnit != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + " " + realEstateProperty.addressUnit;
			}
			if (realEstateProperty.addressCity != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + " " + realEstateProperty.addressCity;
			}
			if (realEstateProperty.addressState != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + " " + realEstateProperty.addressState;
			}
			if (realEstateProperty.addressZip != null) {
				realEstateProperty.displayLabel = realEstateProperty.displayLabel + " " + realEstateProperty.addressZip;
			}
			if (realEstateProperty.displayLabel == "") {
				realEstateProperty.displayLabel = "NA";
			}
			return realEstateProperty;
		}
	}

	/*********
	 * Copy Button
	 * made with primeng
	 */
	onOpenFormCopyTo() {
		console.log("Copy Proforma:" + JSON.stringify(this.proforma));
		const ref = this.dialogService.open(ProformaCopyToFormComponent, {
			data: {
				proforma: this.proforma,
			},
			header: "Copy " + this.proforma.name + "  (#" + this.proforma.proformaId + ")",
			width: "auto",
		});

		ref.onClose.subscribe((copiedProforma: any) => {
			// this.doUpdate.emit(this.proforma);
			this.doOpenCopiedProforma.emit(copiedProforma);
		});
	}

	/*********
	 * Copy Button
	 * made with primeng
	 */
	onOpenFormCopyFrom() {
		console.log("Copy Proforma:" + JSON.stringify(this.proforma));
		const ref = this.dialogService.open(ProformaCopyFromFormComponent, {
			data: {
				proforma: this.proforma,
			},
			header: "Copy From",
			width: "auto",
		});

		ref.onClose.subscribe((copiedProforma: any) => {
			// this.doUpdate.emit(this.proforma);
			this.doOpenCopiedProforma.emit(copiedProforma);
		});
	}

	copyProforma(proforma: Proforma) {
		try {
			this.formLoading = true;
			this.proformaService.copyTo(proforma).subscribe(
				(res) => {
					console.log("Proforma-Copy SUCCESS: " + JSON.stringify(res));

					// this.alertService.success(res, true);
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: "New Proforma " + proforma.name + " created.",
					});
				},
				(err) => {
					console.log("Proforma-Update FAIL: " + JSON.stringify(err));
					this.messageService.add({
						severity: "error",
						summary: JSON.stringify(err),
						life: 3000,
					});
				},
				() => {
					this.formLoading = false;
				}
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
		}
	}


	//Add new property lead profile when creating new proforma
	formAddPropertyLead() {
		console.log(
			"Testing PropertyLead: " + JSON.stringify(this.propertyLeadProfile)
		);
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Property Lead Profile",
			isDisplayOwnerProfile: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			PropertyLeadProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);
			this.propertyLeadProperties = [];
			if (this.proforma != undefined) {
				this.proforma.propertyLeadProfileId = data.propertyLeadProfileId;
			}
			this.setPropertyLead(data?.propertyLeadProfile);
			this.form1.patchValue({
				propertyLeadProfileId: data.propertyLeadProfileId
			});
			dialogRef.close();
		});
	}
	formAddRealtorProfile() {
		console.log(
			"Testing RealtorProfile: " + JSON.stringify(this.realtorProfile)
		);
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			// realtorProfile: this.realtorProfile,
			title: "Add RealtorProfile",
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		dialogRef.componentInstance.doAddRealtor.subscribe((data) => {
			console.log("Dialog output:", data);

			this.realtorProperties = [];
			this.fetchRealtor();
			this.realtorProfile = data;
			if (this.proforma != undefined) {
				this.proforma.realtorProfileId = data.realtorProfileId;
			}
			this.form1.patchValue({
				realtorProfileId: data.realtorProfileId

			});

			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			//	this.updateOwnerStmtCB(data);

			// close the dialogBox
			dialogRef.close();
		});
	}
	formAddOwnerLeadProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = "80vw";
		dialogConfig.maxWidth = "1600px";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			// ownerLeadProfile: this.ownerLeadProfile,
			title: "Add Owner Lead Profile",
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerLeadProfileComponent, dialogConfig);
		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);

			this.ownerLeadProperties = [];
			if (this.proforma != undefined) {
				this.proforma.ownerLeadProfileId = data.ownerLeadProfileId;
			}
			this.fetchOwnerLeadProfile();
			this.ownerLeadProfile = data;
			this.form1.patchValue({
				ownerLeadProfileId: data.ownerLeadProfileId

			});

			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			//	this.updateOwnerStmtCB(data);

			// close the dialogBox
			dialogRef.close();
		});
	}


	/*********
		* Edit Property Lead Profile
		*
		*/
	formEditPropertyLead() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyLeadProfile: this.propertyLeadProfile,
			title: 'Property Lead'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyLeadProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/*********
	* Edit Realtor Profile
	*
	*/
	formEditRealtorProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			realtorProfile: this.realtorProfile,
			title: 'Edit Realtor Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);

				this.realtorProperties = [];
				this.fetchRealtor();
				this.form1.patchValue({
					realtorProfileId: data.realtorProfileId

				});

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/*********
* Edit Owner Lead Profile
*
*/
	formEditOwnerLeadProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerLeadProfile: this.ownerLeadProfile,
			title: 'Edit Owner Lead Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerLeadProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);

				this.ownerLeadProperties = [];
				this.fetchOwnerLeadProfile();
				this.form1.patchValue({
					ownerLeadProfileId: data.ownerLeadProfileId
				});

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/* Search for user */
	findUsersWith(queryString: string) {
		this.userService.findUsersWithEmployeeRelationship(queryString).pipe(first()).subscribe(

			(data: any) => {
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.agentUserSuggestions = [];
				this.agentUserSuggestions = data.data.userSummaryList;
				// console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/* On each keystroke search for the user */
	onKeyInput(event) {
		let query = event.query;
		this.findUsersWith(query);
		return this.agentUserSuggestions;
	}

	changePropertyLeadProfile(propertyLeadProfile: any) {
		if (this.propertyLeadProperties.length > 0) {
			this.propertyLeadProperties.forEach(propertyLeadPropery => {
				if (propertyLeadPropery.propertyLeadProfileId == propertyLeadProfile.value) {
					this.propertyLeadProfile = propertyLeadPropery;
				}
			});
		}
	}

	changeRealtorProfile(realtorProfile: any) {
		if (this.realtorProperties.length > 0) {
			this.realtorProperties.forEach(realtorProperty => {
				if (realtorProperty.realtorProfileId == realtorProfile.value) {
					this.realtorProfile = realtorProperty;
				}
			});
		}
	}

	changeOwnerLeadProfile(ownerLeadProfile: any) {
		if (this.ownerLeadProperties.length > 0) {
			this.ownerLeadProperties.forEach(ownerLeadProperty => {
				if (ownerLeadProperty.ownerLeadProfileId == ownerLeadProfile.value) {
					this.ownerLeadProfile = ownerLeadProperty;
				}
			});
		}
	}

	sendFullMail() {

		if (this.form1.get('status')?.value !== 1) {
			this.messageService.add({
				severity: 'warn',
				summary: 'Not Allowed',
				detail: 'You can only share a Proforma when the status is Published.',
				life: 4000
			});
			return; // stop execution
		}

		// let propertyName = "";
		// if (this.propertyLeadProfile?.subjAdrDevelopmentName != undefined) {
		// 	propertyName = propertyName + this.propertyLeadProfile?.subjAdrDevelopmentName;
		// }
		// if (this.propertyLeadProfile?.subjAdrUnit != undefined) {
		// 	propertyName = propertyName == "" ? '#' + this.propertyLeadProfile?.subjAdrUnit : propertyName + " #" + this.propertyLeadProfile?.subjAdrUnit;
		// }
		// if (this.propertyLeadProfile?.subjAdrStreet != undefined && propertyName == "") {
		// 	propertyName = this.propertyLeadProfile?.subjAdrStreet;
		// }

		// let regards = '';
		// regards = this.createdBy?.firstName != undefined ? this.createdBy?.firstName : '';
		// regards = this.createdBy?.lastName != undefined ? regards == '' ? this.createdBy?.lastName : regards + ', ' + this.createdBy?.lastName : regards + '';
		// regards = regards == '' ? this.createdBy?.emailAddress != undefined ? this.createdBy?.emailAddress : '' : regards + '<br>' + (this.createdBy?.emailAddress != undefined ? this.createdBy?.emailAddress : '');
		// regards = regards == '' ? (this.createdBy?.mobilePhone != undefined ? this.createdBy?.mobilePhone : '') : (regards + '<br>' + (this.createdBy?.mobilePhone != undefined ? this.createdBy?.mobilePhone : ''));
		// regards = regards == '' ? (this.createdBy?.title != undefined ? this.createdBy?.title : '') : (regards + '<br>' + (this.createdBy?.title != undefined ? this.createdBy?.title : ''));

		const dialogConfig = new MatDialogConfig();
		this.msg = new Msg();
		// this.msg.subject = 'Proforma Details';
		// this.msg.emailHtml = 'Hi ' + this.ownerLeadProfile?.firstName
		// 	+ ' <br> <br> Please find your rent analysis for ' + propertyName
		// 	+ ' <br> <br> <a href="' + this.shareProformaEmail + '">' + this.shareProformaEmail + '</a>'
		// 	+ ' <br> <br> Please explore the income potential by selecting between Stable, Contracting, and Expanding markets to see how our analysis indicates your home will perform under varying economic conditions.'
		// 	+ '<br> <br> I look forward to learning more about your home and am available to discuss anytime at your convenience. <br> <br>'
		// 	+ 'Best, <br>'
		// 	+ regards;

		this.msg.topic = 700; // proforma
		this.msg.topicId = this.proformaId;

		// settings
		// dialogConfig.disableClose = false;
		// dialogConfig.autoFocus = true;
		// dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "send mail",
			msg: this.msg,
			toEmails: this.ownerLeadProfile?.emailAddress,
			ccEmails: '',
			bccEmails: '',
			proforma: this.proforma,
			msgTemplateId: 779 //809
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef: any = this.dialog.open(SendFullMailComponent, dialogConfig);

		dialogRef.componentInstance.doAdd.subscribe((data: any) => {
			console.log("Dialog output:", data);
			this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + this.proforma?.name + ' shared successfully.', life: 3000 });
			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			// this.addMsgCB(data);

			// close the dialogBox
			// dialogRef.close();
		});
	  }

	/*********
	 * Add New Button for sending both mail and sms
	 *
	 */
	onOpenFormAddMailAndSMS() {

		if (this.form1.get('status')?.value !== 1) {
			this.messageService.add({
				severity: 'warn',
				summary: 'Not Allowed',
				detail: 'You can only share a Proforma when the status is Published.',
				life: 4000
			});
			return; // stop execution
		}

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '80vw';
		dialogConfig.maxWidth = '95vw';

		let msgTopics = [700];
		let msgTopicIds = [this.proformaId];
		if(this.form1.value?.realtorProfileId)
		{
				msgTopicIds.push(this.form1.value?.realtorProfileId);
				msgTopics.push(510);
		}
		if(this.form1.value?.ownerLeadProfileId)
		{
				msgTopicIds.push(this.form1.value?.ownerLeadProfileId);
				msgTopics.push(2300);
		}
		if(this.form1.value?.propertyLeadProfileId)
		{
			msgTopicIds.push(this.form1.value?.propertyLeadProfileId);
			msgTopics.push(2400);
		}
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'New Mail',
			msgTopic: msgTopics, // BizDev, OwnerLeadProfile
			msgTopicId: msgTopicIds,
			// msgTemplateData: this.msgTemplateData,
			templateMsgAudience: 700, //Bizdev templates only
			msgContextId: 9, // BizDev
			msgTemplateId: 809,
			stripVars: ['{{proforma.pdf.proforma}}']
		};

		this.mailComposeLoading = true;

		// Step 1: fetch the template to check if it contains the PDF flag variable
		this.msgTemplateService.findById(dialogConfig.data.msgTemplateId)
			.pipe(first(), catchError(() => of(null)))
			.subscribe({
				next: (res: any) => {
					const templateHtml: string = res?.data?.msgTemplate?.emailHtml || '';
					const templateSms: string = res?.data?.msgTemplate?.mobileText || '';
					const shouldAttachPdf = templateHtml.includes('{{proforma.pdf.proforma}}') || templateSms.includes('{{proforma.pdf.proforma}}');

					if (!shouldAttachPdf) {
						// Template does not request PDF — open dialog immediately
						this.mailComposeLoading = false;
						this.openProformaMailDialog(dialogConfig);
						return;
					}

					// Step 2: template has {{proforma.pdf.proforma}} — fetch and attach the PDF
					this.proformaService.getPdfAsBlob(this.proforma?.confId)
						.pipe(first(), catchError(() => of(null)))
						.subscribe({
							next: (response: any) => {
								const blob = response?.body as Blob;
								if (blob && blob.size > 0) {
									const pdfFileName = `${this.proforma?.confId || 'Proforma'} - Proforma.pdf`;
									const pdfFile = new File([blob], pdfFileName, { type: 'application/pdf' });
									dialogConfig.data.initialAttachments = [pdfFile];
								} else {
									this.alertService?.error('No PDF received. Opening mail without attachment.');
								}
								this.mailComposeLoading = false;
								this.openProformaMailDialog(dialogConfig);
							},
							error: (err: any) => {
								console.error('Error fetching proforma PDF:', err);
								this.alertService?.error('Failed to fetch PDF. Opening mail without attachment.');
								this.mailComposeLoading = false;
								this.openProformaMailDialog(dialogConfig);
							}
						});
				},
				error: () => {
					// Template fetch failed — open dialog without PDF
					this.mailComposeLoading = false;
					this.openProformaMailDialog(dialogConfig);
				}
			});
	}

	private openProformaMailDialog(dialogConfig: MatDialogConfig): void {
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxMailSMsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
		(data: any) => {
			console.log('Dialog output:', data);
			// close the dialogBox
			dialogRef.close();
		});

		dialogRef.componentInstance.doUpdate.subscribe(() => {
			dialogRef.close();
		});
	}

	sendEmailOrSmsOfProforma(flagForEmailOrText: any) {

		const data = {
			proformaId: this.proforma.proformaId,
			ownerLeadProfileId: this.proforma.ownerLeadProfileId,
			firstName: this.proforma?.ownerLeadProfile?.firstName,
			employeeName: (this.logInUser?.firstName ?? "") + " " + (this.logInUser?.lastName ?? ""),
			mobile: this.proforma?.ownerLeadProfile?.mobilePhone,
			emailAddress: this.proforma?.ownerLeadProfile?.emailAddress,
			commissionRate: this.proforma?.ownerLeadProfile?.mgmtFeePCT * 100,
			estGrossRev: this.proforma?.ownerLeadProfile?.estGrossRev,
			bizdevLink: "https://www.kbmresorts.com/bizdev/" + this.proforma?.confId,
			contactPreference: flagForEmailOrText,
			propertyAddress: [
				this.proforma?.ownerLeadProfile?.subjAdrDevelopmentName,
				this.proforma?.ownerLeadProfile?.subjAdrStreet,
				this.proforma?.ownerLeadProfile?.subjAdrCity,
				this.proforma?.ownerLeadProfile?.subjAdrState,
				this.proforma?.ownerLeadProfile?.subjAdrCountry
			].filter(part => part).join(', ')
		}
		try {
			//pass this.confId in parameter below in kbmresorts
			this.proformaService.sendEmailOrSmsForBizdev(data)
				.subscribe(
					(res: any) => {
						console.log('findAllproformaObj Data: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Send Successfully', life: 3000 });
					},
					(err: any) => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onGetMetaInfo(meta: string) {
		this.dateOverLappingMsg = meta;
	}

	copyPublicLink() {
		const url = 'https://www.kbmresorts.com/bizdev/' + this.proforma?.confId;
		navigator.clipboard.writeText(url).then(() => {
			this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Public link copied to clipboard', life: 3000 });
		}).catch(() => {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy link', life: 3000 });
		});
	}

	toggleSendToProspectForm() {
		this.showSendToProspectForm = !this.showSendToProspectForm;
		if (this.showSendToProspectForm) {
			// Pre-fill email from owner lead profile
			const email = this.ownerLeadProfile?.emailAddress ?? this.proforma?.ownerLeadProfile?.emailAddress ?? '';
			this.sendToProspectPayload = {
				recipientEmail: email,
				customSubject: 'Your KBM Resorts Rental Income Analysis',
				customMessage: ''
			};
		}
	}

	sendToProspect() {
		if (!this.proformaId) return;
		this.sendToProspectLoading = true;
		const payload = {
			proformaId: this.proformaId,
			recipientEmail: this.sendToProspectPayload.recipientEmail || null,
			customSubject: this.sendToProspectPayload.customSubject || null,
			customMessage: this.sendToProspectPayload.customMessage || null
		};
		this.proformaService.sendProformaToOwner(payload).pipe(first()).subscribe({
			next: (res: any) => {
				this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Rental Income Analysis sent to prospect.', life: 4000 });
				this.showSendToProspectForm = false;
				this.sendToProspectLoading = false;
			},
			error: (err: any) => {
				this.messageService.add({ severity: 'error', summary: 'Send Failed', detail: err?.error?.message ?? 'Could not send email. Please try again.', life: 5000 });
				this.sendToProspectLoading = false;
			}
		});
	}

	loadViewStats() {
		if (!this.proformaId) return;
		this.viewStatsLoading = true;
		this.proformaService.getViewStats(this.proformaId).pipe(first()).subscribe({
			next: (res: any) => {
				this.viewStats = res?.data?.viewStats ?? null;
				this.viewStatsLoading = false;
			},
			error: () => {
				this.viewStatsLoading = false;
			}
		});
	}

	refreshViewStats() {
		this.loadViewStats();
	}

	formatLastViewed(lastViewedAt: string): string {
		if (!lastViewedAt) return '';
		const now = new Date();
		const viewed = new Date(lastViewedAt);
		const diffMs = now.getTime() - viewed.getTime();
		const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
		if (diffDays === 0) {
			return 'Today at ' + viewed.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		}
		if (diffDays === 1) return 'Yesterday';
		return diffDays + ' days ago';
	}

	async downloadAsPdf(event: Event): Promise<void> {
    event.preventDefault();

	if (!this.proformaId || this.pdfLoading) {
		return;
	}
	this.pdfLoading = true;

    try {
      this.proformaService.getPdfAsBlob(this.proforma?.confId)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
			this.pdfLoading = false;
            const blob = response.body as Blob;
            if (!blob || blob.size === 0) {
              throw new Error('No PDF data received from server');
            }

            // Extract filename from header
            const contentDisposition = response.headers.get('content-disposition');
            let filename = 'owner_statement.pdf';
            if (contentDisposition) {
              const match = contentDisposition.match(/filename="?([^"]+)"?/);
              if (match && match[1]) {
                filename = match[1];
              }
            }
            
            this.downloadPdf(blob, filename);
            
          },
          error: (error: any) => {
			this.pdfLoading = false;
            console.error('Error fetching PDF:', error);
            this.alertService?.error('Failed to generate PDF. Please try again.');
            
          }
        });
    } catch (error) {
	  this.pdfLoading = false;
      console.error('Error generating PDF:', error);
      this.alertService?.error('Failed to generate PDF. Please try again.');
      
    }
  }

   /**
   * Download PDF from blob
   */
  private downloadPdf(blob: Blob, filename: string = 'owner_statement.pdf'): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
